'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _OrderButton = require('./OrderButton.less');

var _OrderButton2 = _interopRequireDefault(_OrderButton);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _Spinner = require('../../web/Spinner/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _I18n = require('@wix/wixrest-utils/dist/I18n');

var _I18n2 = _interopRequireDefault(_I18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _I18n$getComponentHea = _I18n2.default.getComponentHeader(''),
    i18n = _I18n$getComponentHea.i18n;

var _default = (_temp2 = _class = function (_React$Component) {
    (0, _inherits3.default)(_default, _React$Component);

    function _default() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, _default);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = _default.__proto__ || (0, _getPrototypeOf2.default)(_default)).call.apply(_ref, [this].concat(args))), _this), _this.onClick = function (e) {
            e.preventDefault();
            _this.props.onClick();
        }, _this.parseQuadCssAttributeValue = function (value) {
            if (i18n.isRtlDir()) {
                value = value.split(' ');
                if (value.length === 4) {
                    var temp = value[1];
                    value[1] = value[3];
                    value[3] = temp;
                } else if (value.length === 3) {
                    value[3] = value[1];
                    value[1] = '0px'; // 'initial' didn't work :(
                }

                return value.join(' ');
            } else {
                return value;
            }
        }, _this._onKeyDown = function (e) {
            _this.props.onKeyDown(e);
        }, _this.focus = function () {
            if (_this.button) {
                _this.button.focus();
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(_default, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                type = _props.type,
                showSpinner = _props.showSpinner,
                spinnerColor = _props.spinnerColor,
                spinnerClass = _props.spinnerClass,
                className = _props.className,
                dataHook = _props.dataHook;

            var classNames = (0, _classnames3.default)(_OrderButton2.default.wrapper, _OrderButton2.default['btn-' + type], className, (0, _defineProperty3.default)({}, _OrderButton2.default.showSpinner, showSpinner));
            var props = ['width', 'backgroundColor', 'color', 'minWidth', 'textTransform', 'display', 'justifyContent', 'fontSize', 'textAlign'];
            var style = {};

            props.forEach(function (prop) {
                if (_this2.props[prop]) {
                    style[prop] = _this2.props[prop];
                }
            });

            return _react2.default.createElement(
                'a',
                { href: '#',
                    ref: function ref(el) {
                        return _this2.button = el;
                    },
                    className: classNames,
                    style: style,
                    'data-hook': dataHook,
                    onKeyDown: this._onKeyDown,
                    onClick: this.onClick },
                _react2.default.createElement(
                    'div',
                    { className: _OrderButton2.default.childrenWrapper },
                    this.props.children
                ),
                _react2.default.createElement(
                    'div',
                    { className: _OrderButton2.default.spinnerWrapper },
                    _react2.default.createElement(_Spinner2.default, { radius: 20,
                        className: spinnerClass,
                        bordercolor: 'transparent',
                        color: spinnerColor })
                )
            );
        }
    }]);
    return _default;
}(_react2.default.Component), _class.displayName = 'OrderButton', _class.propTypes = {
    spinnerColor: _propTypes2.default.string,
    type: _propTypes2.default.oneOf(['default', 'primary', 'link', 'link-primary']),
    display: _propTypes2.default.oneOf(['block', 'inline-block', 'inline', 'flex', 'inline-flex']),
    width: _propTypes2.default.number,
    showSpinner: _propTypes2.default.bool,
    onClick: _propTypes2.default.func,
    className: _propTypes2.default.string,
    spinnerClass: _propTypes2.default.string,
    onKeyDown: _propTypes2.default.func,
    dataHook: _propTypes2.default.string
}, _class.defaultProps = {
    type: 'default',
    onClick: function onClick() {},
    display: 'block',
    className: '',
    spinnerClass: '',
    spinnerColor: 'white',
    onKeyDown: function onKeyDown() {}
}, _temp2);

exports.default = _default;